import axios from 'axios';
import Vue from 'vue'

export default {
    saveArticle(formData) {
        return axios.post("/api/article/save/", formData)
            .then(response => {

                if (response && response.data) {
                    Vue.prototype.$snotify.success("Article ajoutée avec succès");
                    return response.data;
                }
            })
            .catch(error => { Vue.prototype.$snotify.error(error); })
    },

    
    getArticle(page, pageSize) {
        return axios.get('/api/article/list',{ params: {page: page, pageSize: pageSize } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeArticle(articleId) {
        return axios.post('/api/article/delete', {id : articleId})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Article supprimé avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


}